// #region Imports
// #endregion
const cartModule = {
    // #region Vars
    namespaced: true,
    // #endregion
    // #region Properties
    state: {
        _carts: [],
        _cart: null,
        _request: null
    },
    // #endregion
    // #region getter
    getters: {
        // #region Cart
        cart(state) {
            return state._cart;
        },
        allCarts(state) {
            return state._carts;
        },
        hasCart(state) {
            return !utils.isNullOrEmpty(state._cart);
        },
        cartID(state) {
            return state._cart?.cartID ?? '';
        },
        cartTitle(state) {
            if (state._cart?.totalNetAmount ?? 0 === 0) {
                return utils.formatNumberWithDcp(state._cart?.totalNetAmount ?? 0, 2) + " " + state._cart?.currency;
            }
            else {
                return state._cart?.cartNumber ?? '';
            }
        },
        cartNumber(state) {
            return state._cart?.cartNumber ?? '';
        },
        totalLines(state) {
            return state._cart?.lineCount ?? 0;
        },
        totalAmount(state) {
            return state._cart?.totalNetAmount ?? 0;
        },
        totalAmountFormatted(state) {
            return utils.formatNumberWithDcp(state._cart?.totalNetAmount ?? 0, 2) + " " + state._cart?.currency;
        },
        // #endregion
        // #region Request
        request(state) {
            return state._request;
        },
        hasRequest(state) {
            return !utils.isNullOrEmpty(state._request) && (state._request?.lineCount ?? 0) > 0;
        },
        requestTotalLines(state) {
            return state._request?.lineCount ?? 0;
        },
        requestID(state) {
            return state._request?.cartID ?? '';
        },
        requestNumber(state) {
            return state._request?.cartNumber ?? '';
        },
        // #endregion
    },
    // #endregion
    // #region Mutations
    mutations: {
        startup(state, appHost) {
            appHost.store.subscribe((m, s) => {
                if (m.type === "session/loggedIn") {
                    appHost.store.commit('carts/load', m.payload);
                }
                if (m.type === "session/loggedOut") {
                    appHost.store.commit('carts/load', m.payload);
                }
                if (m.type === "session/setUser") {
                    appHost.store.commit('carts/load', m.payload);
                }
                if (m.type === "session/anonymous") {
                    appHost.store.commit('carts/load', m.payload);
                }
            });
        },
        load(state) {
            if (!appHost.session?.features?.carts) {
                return;
            }
            appHost.api.get("commerce/carts?precedence=1&cartType=S,A")
                .then((r) => {
                let tCarts = [];
                let tRequest = null;
                r.data.forEach((e) => {
                    if (e.cartType === "A") {
                        if (e.lineCount > 0) {
                            tRequest = e;
                        }
                    }
                    else {
                        tCarts.push(e);
                    }
                });
                //Data
                state._carts = tCarts;
                state._request = tRequest;
                //Current
                state._cart = state._carts.find((e) => e.isActive);
            })
                .catch((e) => {
                state._carts = [];
                state._cart = undefined;
                state._request = undefined;
            });
        },
        setCart(state, cart) {
            if (!cart) {
                return;
            }
            if (cart.cartType == 'S') {
                //Optimize
                if (cart.cartID == state._cart?.cartID) {
                    cart.isActive = true;
                }
                //Search
                let tIndex = state._carts.findIndex((e) => e.cartID == cart.cartID);
                //Set
                if (tIndex >= 0) {
                    state._carts[tIndex] = cart;
                }
                else {
                    state._carts.push(cart);
                }
                //Current
                state._cart = state._carts.find((e) => e.isActive);
            }
            else if (cart.cartType == "A") {
                //Remove
                if (state._cart?.cartID == cart.cartID) {
                    state._cart = undefined;
                }
                //Array
                let tIndex = state._carts.findIndex((e) => e.cartID == cart.cartID);
                if (tIndex >= 0) {
                    state._carts.splice(tIndex, 1);
                }
                //Set
                state._request = cart;
            }
        },
        removeCart(state, cart) {
            // #region Remove
            if (state._cart?.cartID == cart.cartID) {
                state._cart = undefined;
            }
            if (state._request?.cartID == cart.cartID) {
                state._request = undefined;
            }
            // #endregion
            // #region Removes
            let tIndex = state._carts.findIndex((e) => e.cartID == cart.cartID);
            if (tIndex >= 0) {
                state._carts.splice(tIndex, 1);
            }
            // #endregion
        },
    },
    // #endregion
};
export default cartModule;
